export * from './listing-details-promoted-content.component';
